document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.teaser-element').forEach(function (card) {
        var link = card.querySelector('a');
        if (!link) return;

        card.style.cursor = 'pointer';
        card.addEventListener('click', function (e) {
            if (e.target.closest('a')) return;
            window.location.href = link.href;
        });
    });
});